module.exports = __webpack_public_path__ + "img/5.1bf28ed8.png";